module.exports = __webpack_public_path__ + "img/Banner-principal-1.d34fcd7d.webp";